export default __webpack_public_path__ + "static/media/withdraw-icon.219c2981.webp";